import { useState } from 'react';
import SchemaOrg from '@/components/feature/SchemaOrg';

const faqs = [
  {
    question: '哥布林的洞窟是什么类型的游戏？',
    answer: '哥布林的洞窟是一款黑暗奇幻风格的地下城冒险角色扮演游戏（RPG），玩家将在错综复杂的洞穴系统中探索，击败怪物、收集装备、解锁剧情，最终挑战哥布林之王图尔格。游戏结合了动作战斗、装备锻造、角色养成和深度剧情等多重元素。',
  },
  {
    question: '新手应该选择哪个职业开局？',
    answer: '强烈推荐新手选择战士职业开局。战士拥有全职业最高的生命值和防御力，容错率极高，即使操作失误也不容易被秒杀。战士的盾卫流派可以让你在熟悉怪物攻击模式的同时保持安全。当你对游戏机制足够熟悉后，再尝试法师或盗贼等高难度职业。',
  },
  {
    question: '哥布林的洞窟有多少层？',
    answer: '哥布林的洞窟共有七层主要区域：第一层废弃矿道、第二层幽暗地窟、第三层失落之城、第四层遗忘图书馆、第五层熔岩深渊、第六层暗影回廊和第七层王座之间（最终BOSS图尔格所在地）。此外还有大量隐藏房间和秘密区域散布在各层之间。',
  },
  {
    question: '如何在哥布林的洞窟中快速升级？',
    answer: '快速升级的关键是高效刷怪路线的选择。推荐在第一层刷到5级后，前往第二层的地下湖区刷洞穴水元素（经验效率高且掉落材料实用）。15-20级阶段建议在第三层居民区刷骷髅军团，配合经验加成药水效率最高。另外不要忽视支线任务，很多任务奖励的经验值远超同等级打怪。',
  },
  {
    question: '哥布林的洞窟有隐藏结局吗？',
    answer: '是的，哥布林的洞窟拥有三个不同的结局路线。普通结局通过直接击败图尔格即可达成；真结局需要收集全部12块知识碎片了解完整历史后击败图尔格；隐藏结局则需要完成全部37个隐藏房间的探索、与所有NPC好感度达标，并在最终战斗中选择特殊对话选项。隐藏结局将解锁New Game+模式和唯一的神话武器。',
  },
  {
    question: '哥布林的洞窟支持多人联机吗？',
    answer: '哥布林的洞窟目前为单人游戏，但队伍系统允许你同时控制多名角色。游戏中的NPC队友（如艾拉娜、格拉克等）在解锁后可以加入你的队伍，每位队友都有独立的技能树和装备系统。开发团队表示多人合作模式正在开发中，将在后续更新中推出。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <SchemaOrg type="FAQPage" faqData={faqs} />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm">关于哥布林的洞窟，你可能想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h4 className="text-sm md:text-base font-medium text-foreground-900 pr-6">
                  {faq.question}
                </h4>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}